import React from "react";

const TicketHeaderSkeleton = () => (
  <div className="flex items-center gap-3 px-4 py-3 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 animate-pulse">
    <div className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-700 flex-shrink-0" />
    <div className="space-y-2 flex-1">
      <div className="h-3.5 bg-slate-200 dark:bg-slate-700 rounded w-32" />
      <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-48" />
    </div>
  </div>
);

export default TicketHeaderSkeleton;
